export default {
  computed:{
    policyholderDetail(){
      let {
        isrd_title,
        isrd_lst_nm,
        isrd_dob,
        isrd_fst_nm,
        id_type,
        id_no,
        mobile_no,
        isrd_dob_date,
        email,
        isrd_com_nm,
        phone_no,
        phone,
        bsns_nature_id,
        contact_nm,
        contact_occ_id,
        contact_phone,
        contact_email,
        verified
      } = this.customer_profile||{}
      if(verified!=20)
        return {}
      return {
        isrd_title,
        isrd_lst_nm,
        isrd_dob,
        isrd_fst_nm,
        id_type,
        id_no,
        mobile_no:mobile_no?mobile_no:phone,
        isrd_dob_date,
        email,
        isrd_com_nm,
        phone_no,
        bsns_nature_id,
        contact_nm,
        contact_occ_id,
        contact_phone,
        contact_email,
      }
    }
  }
}
